// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Content
 */
export interface Content {
  /**
   *
   */
  category?: string | null;
}

/**
 * Check if a given object implements the Content interface.
 */
export function instanceOfContent(value: object): value is Content {
  return true;
}

export function ContentFromJSON(json: any): Content {
  return ContentFromJSONTyped(json, false);
}

export function ContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Content {
  if (json == null) {
    return json;
  }
  return {
    category:
      json["category"] === undefined
        ? undefined
        : json["category"] === null
        ? null
        : json["category"],
  };
}

export function ContentToJSON(json: any): Content {
  return ContentToJSONTyped(json, false);
}

export function ContentToJSONTyped(
  value?: Content | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    category: value["category"],
  };
}
